export default "__VITE_PUBLIC_ASSET__8dd09b36__"